
export const TargetObjectIdEnum = {
    ConstUserGroup: "00000000-0000-0000-0000-000000000000",
    External: "ffffffff-ffff-ffff-ffff-ffffffffffff",
}